import "./App.css";
import React, { useEffect } from "react";
import { nanoid } from "nanoid";
import Routes from "./Routes/Routes";
import { ToastContainer } from "react-toastify";
import { FormProvider } from "./services/Context/FormContext";

function App() {
  useEffect(() => {
    const uuid = localStorage.getItem("uuid");
    if (!uuid) localStorage.setItem("uuid", nanoid());
  }, []);

  return (
    <FormProvider>
      <div>
        <Routes />
        <ToastContainer hideProgressBar />
      </div>
    </FormProvider>
  );
}

export default App;
